// AT-1224 (RN05): `returnUrl` chega por query string — origem não confiável (qualquer um
// pode montar um link `.../login?returnUrl=https://site-malicioso.com`). Antes de navegar
// pra lá com `window.location.href` (fora do roteador do Angular, que nunca sairia do
// próprio app), valida que o host é o done! (ou subdomínio) ou uma URL relativa — mesmo
// raciocínio já usado em `deriveCookieDomain` do lado React (`react-essentials/src/http/auth-session.ts`).
export function isSafeReturnUrl(url: string, doneAppDomain: string): boolean {
    try {
        const parsed = new URL(url, window.location.origin);

        if (doneAppDomain === "localhost")
            return parsed.hostname === "localhost";

        return parsed.hostname === doneAppDomain || parsed.hostname.endsWith(`.${doneAppDomain}`);
    } catch {
        return false;
    }
}

// AT-1224 (RF04): monta a URL absoluta de retorno a partir da raiz do próprio app (ex.:
// `environment.doneDocsApp`) + uma rota capturada pelo guard local (via `state.url`, por
// isso sempre começa com "/") — usado pelas telas de login locais dos apps Angular
// (Docs/Reports/Pointer/People) ao montar o returnUrl que mandam pro login de verdade do
// Workspace. Sem isso, cada app sempre voltava pra raiz depois de relogar, perdendo a
// rota funda no caso residual em que o refresh token também está morto. Ignora qualquer
// valor que não comece com "/" (ex.: alguém navegando direto pra `/login?returnUrl=...`
// com um valor arbitrário) — cai no fallback seguro (raiz do app).
export function buildAbsoluteReturnUrl(appRootUrl: string, capturedPath: string | null | undefined): string {
    if (!capturedPath || !capturedPath.startsWith("/"))
        return appRootUrl;

    return `${appRootUrl.replace(/\/$/, "")}${capturedPath}`;
}
